export const PAGE_TITLE = 'Active Sessions';

export const PAGE_DESCRIPTION =
  'Devices you are currently signed in on. Signing out a device stops it from staying signed in; it may remain active for a few more minutes before it is fully signed out.';

export const EMPTY_MESSAGE = 'No other devices are signed in.';
export const LOAD_ERROR_MESSAGE = 'We could not load your active sessions.';
export const REVOKE_ERROR_MESSAGE = 'We could not sign out that session.';
export const REVOKE_SUCCESS_MESSAGE = 'That device has been signed out.';

export const REVOKE_DIALOG_TITLE = 'Sign out this device?';
export const REVOKE_DIALOG_MESSAGE = 'That device will have to sign in again the next time it needs a new session.';

export const CURRENT_SESSION_LABEL = 'This device';
export const UNKNOWN_DEVICE_LABEL = 'Unknown device';

export const USER_SESSIONS_QUERY_KEY = ['user-sessions'];
